import React from 'react'
import AnnounceExaminerDetail from 'src/modules/AnnounceExaminer/Detail'

const AnnounceExaminerDetailPage = () => {
  return <AnnounceExaminerDetail />
}

export default AnnounceExaminerDetailPage
